export default {
      location:'MIT, Chrompet',
      date:'January 12, 2021'
}